import { getAuth } from 'firebase/auth';

/**
 * Act on an account's response only while it is still signed in on this page.
 * Sign-ins in another tab reach this page; signed out counts as changed too.
 */
export function isSignedInAs(uid: string): boolean {
  return getAuth().currentUser?.uid === uid;
}
